import { Query } from '../../hooks/queries'
import { useContrastQuery } from '../../hooks/use-contrast-query'
import {
  getProtectRulesQuickFilters,
  ProtectRulesQuickFiltersParams,
  ProtectRulesQuickFiltersQueryArgs
} from '../../api/queries/protect-rules'
import { ProtectRulesQuickFilter } from './shared'

export function useProtectRulesQuickFilters(
  organizationUuid: string,
  protectRulesQuickFilterParams?: ProtectRulesQuickFiltersParams
) {
  return useContrastQuery<
    ProtectRulesQuickFiltersQueryArgs,
    ProtectRulesQuickFilter[]
  >(
    [Query.PROTECT_RULES_QUICK_FILTERS, protectRulesQuickFilterParams],
    getProtectRulesQuickFilters,
    {
      organizationUuid,
      ...protectRulesQuickFilterParams
    },
    { keepPreviousData: true }
  )
}
